import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import AxiosConfig from '../../../../config/AxiosConfig';
import { setProfile } from '../../../states/login/loginSlice';

const PrivateRoutes = (_props) => {
  const profile = useSelector((state) => state?.login?.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (profile === null) {
    AxiosConfig.create('get', '/users/refreshUser')
      .call()
      .exit((res) => {
        dispatch(setProfile(res.data.data.user));
        return <Outlet />;
      })
      .catch((_err) => {
        navigate(`/login?redirectTo=${window.location.pathname}`);
      });
  } else {
    return <Outlet />;
  }
};

export default PrivateRoutes;
